import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  update () {
    const engagementType = this.element.querySelector('input[name="dwell_time_distribution"]:checked')?.value
    this.dispatch('change', { detail: { params: { engagement_type: engagementType } } })
  }
}
